import { getProvider, isWxH5 } from "@utils/business";
import { vipOrderAdd } from "@server/vipApi";
import { showLoading, showToast, showToastAsync } from "@utils/utils";
import {
    orderDelayOrderPay,
    orderOrderPay,
    orderPaySuccessCheck
} from "@server/orderApi";
import { getCode, isBindOpenId } from "@utils/user";
import { router } from "@/router";
import config from "@/config";
import { callClientGetWXAppId } from "@utils/appMethods";
import { wxH5Pay } from "@utils/officialAccount";
import { appointOrderPay } from "@server/appoint";

/**
 * 获取购买会员支付参数
 * @param params
 * @returns {Promise<*>}
 */
export const getVipPayQuery = async (params) => {
    const res = await vipOrderAdd(params);
    if (!res.$success) return;
    return res.data
}

/**
 * 获取普通下单支付参数
 * @param params
 * @returns {Promise<*>}
 */
export const getPlacePayQuery = async (params) => {
    const res = await orderOrderPay(params);
    if (!res.$success) return;
    return res.data
}

/**
 * 延长服务下单支付参数
 * @param params
 * @returns {Promise<*>}
 */
export const getDelayOrderPayQuery = async (params) => {
    const res = await orderDelayOrderPay(params);
    if (!res.$success) return;
    return res.data
}

/**
 * 获取抢单下单支付参数
 * @param params
 * @returns {Promise<*>}
 */
export const getGrabOrdersPlacePayQuery = async (params) => {
    const res = await appointOrderPay(params);
    if (!res.$success) return;
    return res.data
}

/**
 * 拉起支付
 * @param payQuery
 * @returns {Promise<unknown>}
 */
export const requestPayment = (payQuery) => {
    return new Promise(resolve => {
        const hideLoading = showLoading('支付中')
        const provider = getProvider();
        uni.requestPayment({
            provider,
            ...payQuery,
            success(res) {
                console.log(res)
                hideLoading();
                resolve({ code: 0, ...res })
            },
            fail(e) {
                hideLoading();
                if (e.errMsg.indexOf('cancel') > -1) {
                    // showToast('取消支付', { custom: 'cancel' })
                    resolve({ code: -1 })
                    return
                }
                // showToast('支付失败~', { custom: 'error' })
                resolve({ code: -2 })
            }
        })
    })
}

/**
 * 继续支付
 * @param orderId
 * @returns {Promise<*>}
 */
export const continuePay = async (orderId) => {
    // #ifdef MP-WEIXIN
    const payQuery = await getPlacePayQuery({
        code: await getCode(),
        orderId,
    });
    if (!payQuery) {
        return;
    }
    const payInfo = await requestPayment(payQuery.payData);
    if (payInfo.code === 0) {
        await showToastAsync('购买成功', { custom: 'success' })
        await orderPaySuccessCheck({ orderId });
    } else {
        payInfo.code === -1 && await showToastAsync('取消支付', { custom: 'cancel' })
        payInfo.code === -2 && await showToastAsync('支付失败', { custom: 'error' })
    }
    return payInfo
    // #endif

    // #ifdef H5
    if (isWxH5()) {
        router[isBindOpenId() ? 'navigateTo' : 'redirectTo']({
            name: 'wxH5Pay',
            query: {
                module: 'orderList',
                orderId
            }
        })
    }
    // #endif
}


const getClientWxAppid = () => {
    return new Promise(resolve => {
        callClientGetWXAppId({}, (data) => {
            console.log('获取客户端wxAppId', data)
            resolve(data.wxAppId)
        })
    })
}

/**
 * 获取创建订单入参 appid
 * @param from
 * @returns {{appId}|{appId: *}}
 */
export const getCreateOrderAppId = async (from) => {
    switch (from) {
        case 'app':
            // // 微信app
            return { appId: await getClientWxAppid() }
        case 'ios':
            // // 微信app
            return { appId: await getClientWxAppid() }
        case 'wxH5':
            // // 微信app
            return { appId: 'wxe6eec2e6ae38c3cd' }
        default:
            return { appId: config.appid }
    }
}

/**
 * 获取支付方式
 * @returns {{payType: number}}
 */
export const getPayType = ((from, index = 0) => {
    switch (from) {
        case 'app':
            // // 微信app
            return { payType: index === 0 ? 2 : 4 }
        case 'ios':
            // // 微信app
            return { payType: 2 }
        case 'wxH5':
            // // 微信app
            return { payType: 3 }
        default:
            return { payType: 1 }
    }
})
